import moment from "moment"

/**
 * Build MongoDB query match object based on filter values
 * @param {Object} filters - Filter configuration
 * @param {Array} filters.statusFilter - Status filter values
 * @param {Array} filters.credentialsFilter - Credentials filter values
 * @param {Object} filters.dateFilter - Date filter configuration
 * @returns {Object} MongoDB match query object
 */
export const buildRequestFields = (filters) => {
  const { statusFilter, credentialsFilter, dateFilter } = filters

  const match = {
    deleted: { $ne: true }
  }

  // Status filter
  const selectedStatus = statusFilter[0]?.value
  if (selectedStatus && selectedStatus !== "all") {
    match.enabled = selectedStatus === "active"
  }

  // Credentials filter
  const selectedCredentials = credentialsFilter[0]?.value
  if (selectedCredentials && selectedCredentials !== "all") {
    switch (selectedCredentials) {
      case "google":
        match.google_id = { $exists: true, $ne: null }
        break
      case "apple":
        match.apple_id = { $exists: true, $ne: null }
        break
      case "facebook":
        match.facebook_id = { $exists: true, $ne: null }
        break
      case "internal":
        match.internal_id = { $exists: true, $ne: null }
        break
      case "stripe":
        match.stripe_customer_id = { $exists: true, $ne: null }
        break
      case "none":
        match.$and = [
          { google_id: { $exists: false } },
          { apple_id: { $exists: false } },
          { facebook_id: { $exists: false } },
          { internal_id: { $exists: false } },
          { stripe_customer_id: { $exists: false } }
        ]
        break
    }
  }

  // Date filter (CMS-style)
  if (dateFilter.type === "preset" && dateFilter.value) {
    // Preset date range (e.g., last 7 days, last 30 days)
    const cutoffDate = moment().subtract(dateFilter.value.days, "days").utc().toISOString()
    match.created = { $gte: cutoffDate }
  } else if (dateFilter.type === "custom" && dateFilter.range) {
    // Custom date range
    const startDate = moment(dateFilter.range.startDate).utc().startOf("day").toISOString()
    const endDate = moment(dateFilter.range.endDate).utc().endOf("day").toISOString()
    match.created = { $gte: startDate, $lte: endDate }
  }

  return { match }
}
